import { useDispatch } from 'react-redux';

import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';
import { playbackActions } from '@rikstv/play-player/src/forces/player.slice';

import { Program } from '../../../forces/channels/channel.types';
import { Link } from '../../../router/Link';

import styles from './TvGuideProgramNavigation.module.css';

type NavigationProps = {
  program: Program;
  isPlayable: boolean;
};

export const TvGuideProgramNavigation: FCC<NavigationProps> = ({ program, isPlayable, children }) => {
  const dispatch = useDispatch();
  if (isPlayable && program.playbackUrl) {
    const handleClick = () => dispatch(playbackActions.requestAutoPlay());
    return (
      <Link
        className={styles.playLink}
        tabIndex={-1}
        to={program.playbackUrl}
        onClick={handleClick}
        role="button"
        onKeyPress={handleClick}>
        {children}
      </Link>
    );
  }

  return <div className={styles.upcoming}>{children}</div>;
};
